
export type FederatedPointerEvent = {};

export const PIXI_CONTAINER_PROPS = [
    'accessible',
    'accessibleChildren',
    'accessibleHint',
    'accessiblePointerEvents',
    'accessibleTitle',
    'accessibleType',
    'alpha',
    'angle',
    'buttonMode',
    'cacheAsBitmap',
    'cacheAsBitmapMultisample',
    'cacheAsBitmapResolution',
    'cullable',
    'cullArea',
    'cursor',
    'filterArea',
    'filters',
    'height',
    'hitArea',
    'interactive',
    'interactiveChildren',
    'isMask',
    'isSprite',
    'localTransform',
    'mask',
    'name',
    'parent',
    'pivot',
    'position',
    'renderable',
    'rotation',
    'scale',
    'skew',
    'sortableChildren',
    'sortDirty',
    'transform',
    'visible',
    'width',
    'worldAlpha',
    'worldTransform',
    'worldVisible',
    'x',
    'y',
    'zIndex',
] as const;

export const PIXI_CONTAINER_SPECIAL_PROPS = [
    ...PIXI_CONTAINER_PROPS,
    'children',
    'responsive',
    'layer',
    'zOrder',

    /**
     * Helper custom prop, opposite of visible.
     * Specify only one parameter
     */
    'invisible',
] as const;